import React from "react";
import { useSelector, useDispatch } from "react-redux";
import "./ItemsList.css";
import { Link } from "react-router-dom";
import { incrementQuantity, decrementQuantity, removeItem } from "../../redux/slices/cart";
import { Plus, Minus, Trash2 } from "lucide-react";

function ItemsList() {
  const { items, isPaymentStep } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const handleIncrement = (id) => {
    if (isPaymentStep) return; // Block when in payment step
    dispatch(incrementQuantity(id));
  };

  const handleDecrement = (id) => {
    if (isPaymentStep) return; // Block when in payment step
    dispatch(decrementQuantity(id));
  };

  const handleRemove = (id) => {
    if (isPaymentStep) return; // Block when in payment step
    dispatch(removeItem(id));
  };

  return (
    <section className="ItemsList">
      {items.length === 0 ? (
        <p>
          Your cart is empty.{" "}
          <Link to="/" className="back-link">
            Back to products
          </Link>
        </p>
      ) : (
        <>
          <table>
            <thead>
              <tr>
                <th>Product</th>
                <th>Price</th>
                <th>Qty</th>
                <th>Total</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {items?.map((item) => (
                <tr key={item.id}>
                  <td className="item-product" data-label="">
                    <img src={item.image} width={75} alt={item.name} />
                    <p>{item.name}</p>
                  </td>
                  <td data-label="Price">${item.price}</td>
                  <td data-label="Quantity">
                    <div className="quantity-controls">
                      <button
                        onClick={() => handleDecrement(item.id)}
                        className="qty-btn"
                        disabled={item.quantity === 1 || isPaymentStep}
                      >
                        <Minus size={16} />
                      </button>
                      <span className="quantity-value">{item.quantity || 1}</span>
                      <button
                        onClick={() => handleIncrement(item.id)}
                        className="qty-btn"
                        disabled={isPaymentStep}
                      >
                        <Plus size={16} />
                      </button>
                    </div>
                  </td>
                  <td data-label="Total">${(item.price * (item.quantity || 1)).toFixed(2)}</td>
                  <td data-label="">
                    <button
                      onClick={() => handleRemove(item.id)}
                      className="remove-btn"
                      disabled={isPaymentStep}
                      style={{ cursor: isPaymentStep ? "not-allowed" : "pointer" }}
                    >
                      <Trash2 size={18} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </section>
  );
}

export default ItemsList;
